/*****
 * Created with WebStorm.
 * Date : 2018/1/23.
 * Author : Ztr.
 * Func : ..
 ******/

import Vue from 'vue';
import Vuex from 'vuex';
import _user from './modules/user';    //用户信息
import _power from './modules/power';  //权限
import _nimSDK from './modules/nimSDK'; //云信聊天SDK相关
// import _webRTC from './modules/webRTC'; //云信音视频SDK相关
import _counselor from './modules/counselor' //医生列表相关
import getters from './getters';

Vue.use(Vuex);
//modules留着扩展
const store = new Vuex.Store({
  modules: {
    user: _user,
    power: _power,
    nimSDK: _nimSDK,
    counselor: _counselor
    // webRTC: _webRTC
  },
  getters: getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js